import React from 'react'
import { Link } from 'react-router-dom';
import DealerQuotationDetailsContent from './show';
// import CustomerOrderDetailsContent from '../../../components/Dashboard/CustomerOrdersListContent/View';

function DealerQuotationDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Quotation Details</h5>
             <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li>Quotations List Details</li>
            </ul> 
          </div> */}
           
          <DealerQuotationDetailsContent />
        </>
      );
}

export default DealerQuotationDetails
